module.exports = __webpack_public_path__ + "static/media/item_5_13_comp.55d73f70.png";